

(function ( $, window, document, undefined) {

  'use strict';
$('a[href^="#"]').on('click', function (e) {
  e.preventDefault();
  var target = this.hash;
  var $target = $(target);
  $('html, body').stop().animate({
    'scrollTop': $target.offset().top
  }, 450, 'swing', function () {
    window.location.hash = target;
  });
});

$('.scrollup').on('click', function(e) {
 $('body,html').animate({
   scrollTop: 0
 }, 800);
 return false;
});
$(window).scroll(function () {
  if ($(this).scrollTop()) {
    $('.scrollup').fadeIn(100);
  } else {
    $('.scrollup').fadeOut(100);
  }
});


})($, window, document);




// WEBPACK FOOTER //
// ./resources/scripts/script.js